import { CardComp, TabsComp, PlainTable, ModalCompAdvance } from "../../../components";
import CalendarComp from "../../../components/Common/CalendarComp";
import { MemberEventHeader } from "../../../utils/TableHeader";
import PageWrapper from "../modules/PageWrapper";
import styled from "styled-components";
import EmptyTable from "../../../components/Common/EmptyTable";
import { useGetMemberEventsQuery } from "../../../store/member/events";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { dateFromString } from "../../../utils";
import moment from "moment";
import MemberEventDetailsModal from "./modules/EventDetailsModal";

export default function MemberEvent() {
  const navigate = useNavigate();
  const todayDate = dateFromString(new Date().toDateString(), true);
  const { data = {}, error, isLoading } = useGetMemberEventsQuery();
  const { event_calendars = [] } = data;
  
  // State for event details modal
  const [showEventModal, setShowEventModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateEvents, setSelectedDateEvents] = useState([]);

  const past_events = event_calendars.filter(({ end_date }) => {
    const end = new Date(end_date).getTime();
    const current = new Date(todayDate).getTime();
    return end < current;
  });
  const ongoing_events = event_calendars.filter(({ start_date, end_date }) => {
    const start = new Date(start_date).getTime();
    const end = new Date(end_date).getTime();
    const current = new Date(todayDate).getTime();
    return current >= start && current <= end;
  });
  const upcoming_events = event_calendars.filter(({ start_date }) => {
    const start = new Date(start_date).getTime();
    const current = new Date(todayDate).getTime();
    return current < start;
  });

  // Calculate statistics
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();

  // Get current month name
  const currentMonthName = moment().format("MMMM");

  // Filter events for current month
  const currentMonthEvents = useMemo(() => {
    return event_calendars.filter(({ start_date }) => {
      const eventDate = new Date(start_date);
      return (
        eventDate.getFullYear() === currentYear &&
        eventDate.getMonth() === currentMonth
      );
    });
  }, [event_calendars, currentYear, currentMonth]);


  useEffect(() => {
    if (error) {
      if (error.status === 401) {
        toast.error("login to continue", { duration: 3000 });
        return navigate("/login");
      }
      console.log(error);
    }
  }, [error, navigate]);

  // Handle date click on calendar
  const handleDateClick = (date, events) => {
    setSelectedDate(date);
    setSelectedDateEvents(events || []);
    setShowEventModal(true);
  };

  const TableDropDown = [
    {
      name: "I'm available",
      action: () => {},
    },
    {
      name: "I'm unavailable",
      action: () => {},
    },
  ];
  const useTab = [
    {
      name: "Ongoing events",
      component: (
        <PlainTable
          marginBottom={"0rem"}
          message={
            isLoading ? (
              <p className="py-4">Loading...</p>
            ) : (
              <EmptyTable Message={""} />
            )
          }
          columns={MemberEventHeader(TableDropDown)}
          data={ongoing_events}
        />
      ),
    },
    {
      name: "Upcoming events",
      component: (
        <PlainTable
          marginBottom={"0rem"}
          message={
            isLoading ? (
              <p className="py-4">Loading...</p>
            ) : (
              <EmptyTable Message={""} />
            )
          }
          columns={MemberEventHeader(TableDropDown)}
          data={upcoming_events}
        />
      ),
    },
    {
      name: "Past events",
      component: (
        <PlainTable
          marginBottom={"0rem"}
          message={
            isLoading ? (
              <p className="py-4">Loading...</p>
            ) : (
              <EmptyTable Message={""} />
            )
          }
          columns={MemberEventHeader(TableDropDown)}
          data={past_events}
        />
      ),
    },
  ];

  return (
    <Wrapper>
      <PageWrapper mainClassName="" title={"Event Calendar"}>
        <section className="mb-2 headline">
          <div className="">
            <div className="rounded-4">
              <div className="calender-container abc">
                <div className="bg-primary1 rounded-4 mb-lg-0 h-100">
                  <div className="">
                    <div className="py-2 mt-5 mb-5">
                      <h2 className="text-center text-white fw-bold mb-0" style={{ fontSize: "28px" }}>
                        {currentMonthName}
                      </h2>
                    </div>
                    <div className="pb-5">
                      <h3 className="text-center text-white fw-bold mb-0" style={{ fontSize: "20px", lineHeight: "1.5" }}>
                        {isLoading
                          ? "Loading events..."
                          : currentMonthEvents.length === 0
                          ? "You have no events to attend this month"
                          : currentMonthEvents.length === 1
                          ? "You have 1 event to attend this month"
                          : `You have ${currentMonthEvents.length} events to attend this month`}
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="h-100">
                  <div className="bg-white rounded-4 h-100 d-flex flex-column justify-content-center" data-tour="member-events-cal">
                    <CalendarComp
                      outLine
                      height={"100%"}
                      events={event_calendars}
                      onDateClick={handleDateClick}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section data-tour="member-events-upcoming">
          <h4 className="fw-bold text-black1 mb-3">Events List</h4>
          <CardComp cardClassName={"border-0 pt-3 px-3"}>
            <div>
              <TabsComp
                tabClassName="w-100"
                lineHeight={"2px"}
                TabArray={useTab}
                borderWidth="3px"
                lineBottom={"24px"}
                input="name"
              />
            </div>
          </CardComp>
        </section>
      </PageWrapper>

      {/* Event Details Modal */}
      <ModalCompAdvance
        show={showEventModal}
        handleClose={() => {
          setShowEventModal(false);
          setSelectedDate(null);
          setSelectedDateEvents([]);
        }}
        size="lg"
        centered={true}
        close={true}
        arrayComp={[
          {
            name: "Event Details",
            component: (
              <MemberEventDetailsModal
                events={selectedDateEvents}
                selectedDate={selectedDate}
                onClose={() => {
                  setShowEventModal(false);
                  setSelectedDate(null);
                  setSelectedDateEvents([]);
                }}
              />
            ),
          },
        ]}
        modalBody={0}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .headline,
  .abc {
    display: grid;
    gap: 1rem;
  }
  @media screen and (min-width: 768px) {
    .abc {
      grid-template-columns: 30% 1fr;
    }
  }
  @media screen and (min-width: 1024px) {
    .headline {
      grid-template-columns: 1fr;
    }
  }
`;
